import { render } from "./master_submissions.html?vue&type=template&id=7c47dc74&external"
import script from "./master_submissions.js?vue&type=script&lang=js&external"
export * from "./master_submissions.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__